import React, {Component} from 'react';
import { fileUrl } from '../../../../../util/file_url';
export default class VideoDisplay extends Component {
    render() {
        return (
            <div id="attachment-display" className="flex-column-centered max-width">
                <video preload="metadata"
                    id="attachment-display-content"
                    className="max-size"
                    src={fileUrl(this.props.filePath)} controls />
            </div>
        );
    }
};